import BaseService from "../baseService";
class ContaContabil extends BaseService {
  constructor(id) {
    const resource = "nfe-ncm/conta-contabil";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new ContaContabil(id);
